module.exports = __webpack_public_path__ + "static/sales-customer-journey-mobile-367571b1e83f9bf192aada3637ba2e82.png";